import styles from './styles.module.css';
import InputLabel from '../../../../components/InputLabel/InputLabel';
import { Icon } from '../../../../components';
import { Icons } from '../../../../components/Icon/Icon';
import { useState } from 'react';

const FormCollapsableRow = ({
    titleLabel,
    titleValue,
    descriptionLabel,
    disabled,
    labelFullWidth,
    children,
    hideHeader = true,
    useGrid = true,
    afterLabel,
    labelWidth,
}: any) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`${styles.row} ${isOpen ? styles.open : ''} ${disabled ? styles.disabled : ''}`}>
            <button
                className={`${styles.toggle} ${hideHeader ? styles.offset : ''}`}
                disabled={disabled}
                onClick={() => {
                    setIsOpen(!isOpen);
                }}
            >
                <Icon icon={Icons.chevronDownFilled} />
            </button>

            <header
                className={`${styles.header} ${hideHeader && isOpen ? styles.hide : ''}`}
                onClick={() => {
                    if (!disabled) {
                        setIsOpen(!isOpen);
                    }
                }}
            >
                <InputLabel
                    fullWidth={false}
                    labelFullWidth={labelFullWidth || !children}
                    label={titleLabel}
                    afterLabel={afterLabel}
                    margin={false}
                    labelWidth={labelWidth}
                />

                {!!descriptionLabel && (
                    <div
                        style={{
                            paddingLeft: 20,
                        }}
                    >
                        <InputLabel
                            fullWidth={false}
                            labelFullWidth={labelFullWidth || !children}
                            label={descriptionLabel}
                            margin={false}
                        />
                    </div>
                )}

                <div
                    style={{
                        flex: 1,
                    }}
                >
                    {titleValue}
                </div>
            </header>

            <div className={`${styles.contentOuter}`}>
                <div className={`${styles.content} ${useGrid ? styles.grid : ''}`}>{children}</div>
            </div>
        </div>
    );
};

export default FormCollapsableRow;
